import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {InformationObligationAnswer} from "../../models/information-obligation-answer.model";
import {InformationObligationService} from "../../providers/information-obligation.service";

@Component({
  selector: 'app-information-obligation-placeholder',
  templateUrl: './information-obligation-placeholder.component.html',
  styleUrls: ['./information-obligation-placeholder.component.scss'],
})
export class InformationObligationPlaceholderComponent implements OnInit {
  informationObligation: string;
  @Input()
  informationObligationAnswer: InformationObligationAnswer;

  @Output()
  emitGeneratedInformationObligation: EventEmitter<string> = new EventEmitter<string>();

  showTerms: boolean = false;
  isAccepted: boolean = false;
  isBusy: boolean;

  constructor(public commonUtils: CommonUtils, private appStateService: AppStateService, private informationObligationService: InformationObligationService) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });

    this.appStateService.updateIsBusySubject(true);
    // this.informationObligationService.getTemplate().subscribe(template => {
    //   this.informationObligation = template;
    //   this.replace();
    //   this.appStateService.updateIsBusySubject(false);
    // })
  }

  replace() {
    this.informationObligation = this.informationObligation.replace('#CLINIC_NAME#', this.informationObligationAnswer.clinicName);
    this.informationObligation = this.informationObligation.replace('#CLINIC_ADDRESS#', this.informationObligationAnswer.clinicAddress);
    this.informationObligation = this.informationObligation.replace('#CLINIC_TAX_ID#', this.informationObligationAnswer.clinicTaxId);
    this.informationObligation = this.informationObligation.replace('#CLINIC_PHONE#', this.informationObligationAnswer.clinicPhone);
    this.showTerms = true;
  }

  onToggleAccept() {
    this.isAccepted = !this.isAccepted;
    if (this.isAccepted) {
      this.emitGeneratedInformationObligation.emit(this.informationObligation);
    } else {
      this.emitGeneratedInformationObligation.emit(null);
    }
  }
}
